// scripts/assets/jquery-alias.js
// This file is used by esbuild alias to redirect 'jquery' calls to global window.jQuery
if (typeof window !== 'undefined' && !window.jQuery && typeof jQuery !== 'undefined') {
    window.jQuery = window.$ = jQuery;
}
module.exports = window.jQuery;

